import { el } from '../utils/dom.js';

export function skeletonStats(n = 6) {
  const items = [];
  for (let i = 0; i < n; i++) {
    items.push(el('div', { class: 'stat' },
      el('span', { class: 'sk line sm', style: 'width:50%' }),
      el('div', { class: 'sk', style: 'height:28px;width:70%;margin-top:8px;border-radius:6px' }),
    ));
  }
  return el('div', { class: 'stats' }, ...items);
}

export function skeletonRows(rows = 5, cols = 5) {
  const tbody = el('tbody', {});
  for (let r = 0; r < rows; r++) {
    const tr = el('tr', {});
    for (let c = 0; c < cols; c++) {
      tr.appendChild(el('td', {}, el('span', { class: 'sk line', style: `width:${60 + Math.random() * 30}%` })));
    }
    tbody.appendChild(tr);
  }
  return el('div', { class: 'table-wrap' },
    el('table', { class: 'table' }, tbody)
  );
}

export function skeletonCard() {
  return el('div', { class: 'card' },
    el('span', { class: 'sk line sm' }),
    el('div', { class: 'sk box mt-3' }),
  );
}

export function emptyState({ icon = '✦', title, message, action }) {
  return el('div', { class: 'empty' },
    el('div', { class: 'empty-icon' }, icon),
    el('h3', {}, title),
    message ? el('p', {}, message) : null,
    action ? action : null,
  );
}
